import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Select,
  MenuItem,
  FormControl,
  ListItemText,
  OutlinedInput,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const EditableSelectCell = ({
  value: initialValue,
  isEdit,
  rowIndex,
  rowUniqId,
  columnName,
  options,
  onChangeData,
}) => {
  const [value, setValue] = useState('');

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  if (!isEdit) {
    return initialValue;
  }

  return (
    <FormControl fullWidth variant="standard">
      <Select
        id={'Select-' + columnName + '-' + rowIndex}
        value={value || ''}
        input={<OutlinedInput />}
        name={columnName + '-' + rowIndex}
        IconComponent={KeyboardArrowDownIcon}
        MenuProps={{ autoFocus: false, sx: { maxWidth: false } }}
        onChange={e => {
          const selected = e.target.value;

          setValue(selected);
          onChangeData({
            index: rowUniqId,
            value: selected,
            columnName,
          });
        }}
      >
        {options.map(option => (
          <MenuItem key={option} value={option} title={option}>
            <ListItemText primary={option} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

EditableSelectCell.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isEdit: PropTypes.bool,
  rowIndex: PropTypes.number,
  rowUniqId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  columnName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChangeData: PropTypes.func.isRequired,
};

export default EditableSelectCell;
